import React from 'react';
import PropTypes from 'prop-types';

import './ServiceItems.css';

import Checktick from '../../../../Components/Common/Svg/Checktick';
import DataArow from '../../../../Components/Common/Svg/DataArrow';

const ServiceItemsC = (props) => {
  return (
    <div className="service-items-container">
      <React.Fragment>
        <div className="product-container">
          {
            props.service && props.service.products && props.service.products.map(product => {
              return (
                <div key={product.price} className={`product ${product.selected ? 'selected' : ''}`} onClick={() => props.onProductSelect(props.service, product)}>
                  {
                    product.selected ?
                      <div className="checktick-container">
                        <Checktick className="checktick-container" />
                      </div>
                      :
                      null
                  }

                  <div className="upper-section">
                    <div className="product-logo"><DataArow /></div>
                    <div className="product-speed">{product.speed}</div>
                  </div>
                  <div className="lower-section">
                    <div className="product-price">+ R{product.price} PM</div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </React.Fragment>
    </div>
  )
}

ServiceItemsC.propTypes = {
  service: PropTypes.object,
  onProductSelect: PropTypes.func
}

const ServiceItems = ServiceItemsC;

export default ServiceItems;